export enum SiteIDEnum {
  VIPCLUB = 1,
}
